// adminFetch — the ONE transport for Admin API calls (2026-10-04).
//
// Admin rights are decided server-side ONLY from the verified Firebase ID token
// (backend admin_auth.require_admin_user: uid ∈ ADMIN_USER_IDS). This helper always attaches a
// freshly refreshed token; it never sends admin_user_id / admin_email as credentials.
// Without a signed-in user it throws instead of sending an unauthenticated admin request.

import { getAuth } from 'firebase/auth';

export default async function adminFetch(url, init = {}) {
  const user = getAuth().currentUser;
  if (!user) {
    throw new Error('adminFetch: no signed-in user');
  }
  const token = await user.getIdToken(true);
  const headers = new Headers(init.headers || {});
  headers.set('Authorization', `Bearer ${token}`);
  return fetch(url, { ...init, headers });
}
